import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import { HiOutlineDocumentSearch } from "react-icons/all";
import { BiTransfer, BiTransferAlt } from "react-icons/bi";

import "./withdraw_styles/withdraw_sec3.css";
import UpperModal from "./withdraw_modals/upper_modal";
import WithdrawTabs from "./withdraw_tabs/withdrawTabs";
import ReactTable from "./reactTable";
import { AXIOS, api_key } from "../../config";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { RiErrorWarningLine } from "react-icons/all";
import CopyAndShortFormer from "../copyAndShortFormer";
import BootstrapTable from 'react-bootstrap-table-next';

import paginationFactory, { PaginationProvider, PaginationTotalStandalone, SizePerPageDropdownStandalone, PaginationListStandalone } from 'react-bootstrap-table2-paginator';
export default function Withdraw_sec3() {
  const columns = [
    {
      text: "Time", dataField: "time",
      sort: true
    },

    { text: "Currency", dataField: "currency" },
    { text: "Amount", dataField: "amount" },
    { text: "Network", dataField: "network" },
    {
      text: "Address", dataField: "address",
      formatter: (cellContent, row) => <CopyAndShortFormer value={cellContent} />
    },
    {
      text: "TXID", dataField: "txid",
      formatter: (cellContent, row) => <CopyAndShortFormer value={cellContent} />
    },
    {
      text: "Fee", dataField: "fee",

    },
    {
      text: "Status", dataField: "status",
      formatter: (cellContent, row) => {
        return cellContent == 1
          ? 'completed'
          : 'pending';
      }
    },
  ]
  const defaultSorted = [{
    dataField: 'time',
    order: 'desc'
  }];
  // const columns = [
  //   { Header: "Time", accessor: "time" },
  //   { Header: "Currency", accessor: "currency" },
  //   { Header: "Amount", accessor: "amount" },
  //   { Header: "Network", accessor: "network" },
  //   { Header: "Address", accessor: "address",
  //   Cell: (row: any) => {
  //     console.log('address', row)
  //     return <CopyAndShortFormer value={row.value}/>
  // }
  // },
  //   { Header: "TXID", accessor: "txid",
  //   Cell: (row: any) => {
  //     console.log('address', row)
  //     return <CopyAndShortFormer value={row.value}/>
  // }
  // },
  //   { Header: "Fee", accessor: "fee" },
  //   { Header: "Status", accessor: "status" },
  // ];
  const [data, setData] = useState([])
  let userid = sessionStorage.getItem('userid')

  const { networkId, recipientwalletAddress, coinName, coinSymbol, coinOfNetworkId } = useSelector((state: any) => state.withdraw);
  const { isLogin } = useSelector((state: any) => state.auth)
  const [nativeBalance, setNativeBalance] = useState('')

  const [walletInfo, setWalletInfo] = useState({
    balance: '',
    symbol: ''
  })

  const [selectedOption, setSelectedOption] = useState({
    label: ''
  });
  console.log('selected option of network', selectedOption)

  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [error, setError] = useState({
    message: '',
    disable: true
  });

  const handleWithdrawAmount = async (e: any) => {
    let value = e.target.value
    setWithdrawAmount(value)
    if (e.target.value.trim() === '') {
      setError({
        message: 'Amount is required field',
        disable: true
      });
    } else {

      if (value > walletInfo.balance) {
        setError({
          message: 'Amount must be less then wallet amount',
          disable: true
        });
      }
      else {

        setError({
          message: '',
          disable: false
        });
      }
    }
  }

  const renderTooltip = (props: any) => (
    <Tooltip id="overlay-right" {...props}>
      Withdrawal amount is determined by asset block confirmation, asset freezing, and single limit. Due to market fluctuations, while withdrawing from the spot account, the final withdrawal amount may differ from the amount you input, and the withdrawal record shall prevail.
    </Tooltip>
  );
  const withdraw = async () => {
    try {
      let endPoint = coinOfNetworkId == '647441da2fb79b25ec8a3b79' ? '/withdrawNative' : '/withdrawOtherCurrency'
      // let endPoint = '/withdrawNative'
      const response = await AXIOS.post(endPoint, {
        api_key: api_key,
        coin_id: coinOfNetworkId,
        user_id: userid,
        network_id: networkId,
        toAddress: recipientwalletAddress,
        amount: withdrawAmount,
        mailPin: '524744',

      });
      toast(response.data.showableMessage)
      getCoinWalletBalance()
      getWithdrawHistory()


      console.log('withdraw response', response)
    }
    catch (error: any) {
      console.log('error while withdraw', error.message)
    }
  }

  const getCoinWalletBalance = async () => {

    let coinBalance = await AXIOS
      .post('getWalletCoinBalance', {
        api_key: api_key,
        user_id: userid,
        symbol: coinSymbol

      })

    setWalletInfo(coinBalance.data.data)
  }


  useEffect(() => {
    if (coinName && isLogin) {
      getCoinWalletBalance()
    }

  }, [coinName]);

  const getWithdrawHistory = async () => {
    try {
      let history = await AXIOS
        .post('withdrawHistory', {
          api_key: api_key,
          user_id: userid
        })


      setData(history.data.data)
    } catch (error) {

    }
  }
  useEffect(() => {
    if (isLogin) {
      getWithdrawHistory()
      getNativeCoinBalance()


    }
  }, [isLogin])
  const getNativeCoinBalance = async () => {
    AXIOS
      .post('getNativeBalance', {
        api_key: api_key,
        user_id: userid


      }).then((response) => { setNativeBalance(response.data.data) })
  }
  const options = {
    custom: true,
    totalSize: data.length
  };


  return (
    <>
      <Container className="mt-5 mb-5" style={{ color: "var(--text-clr)" }}>
        <Row>
          <Col sm={2} className="mt-3">
            <span>Choose Currency</span>
          </Col>
          <Col sm={7} className="mt-3" style={{ color: "var(--text-clr)" }}>
            <div>
              <UpperModal />
            </div>
          </Col>
        </Row>
        <Row className="mt-3" style={{ color: "var(--text-clr)" }}>
          <Col sm={2} className="mt-3">
            <span>Withdrawl Address</span>
          </Col>
          <Col sm={7} className="" style={{ color: "var(--text-clr)" }}>
            <div className="wd_tb_comp mt-3">
              <WithdrawTabs walletInfo={walletInfo} />
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col sm={2} className="mt-3">
            <span>Amount</span>
          </Col>
          <Col sm={7}>
            {
              selectedOption.label != null && <div className="withdraw-amount mt-3">

                <div className="input-wrapper">
                  <input
                    className="search_input"
                    type="number"
                    placeholder="withdrawl amount"
                    value={withdrawAmount}
                    onChange={(e) => handleWithdrawAmount(e)}
                  />
                  <div className='d-flex gap-2'>
                    <Button variant='muted m-0 p-0' className='srh_btn' onClick={() => {
                      setWithdrawAmount(walletInfo.balance); setError({
                        message: '',
                        disable: false
                      });
                    }}>Max</Button>
                    <span className="wd_sp">|</span>
                    <span className="wd_sp">{coinSymbol}</span>
                  </div>
                </div>
                {
                  error.message &&
                  <div className="text-danger">
                    {error.message}
                  </div>
                }
                <div className="mt-2">
                  <p className="p-0 m-0"> <span className="gr_clr">Amount</span> {nativeBalance}
                    <OverlayTrigger
                      placement="right"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip}
                    >
                      <button style={{ background: 'none', border: 'none' }}>
                      <RiErrorWarningLine />
                      </button>
                    </OverlayTrigger>
                  </p>
                  <p className="p-0 m-0"><span className="gr_clr">Quota</span> 10000000 / <span className="gr_clr">1000000</span> </p>
                </div>
              </div>
            }
          </Col>
        </Row>

        {/* Received Amounts */}
        <Row className="mt-3">
          <Col sm={2} className="mt-5">
            <span>Receivable Amount</span>
          </Col>
          <Col sm={7}>
            <div className="receive_amounts d-flex justify-content-between mt-5 mb-5">
              <div className="d-flex gap-2">
                <span>{withdrawAmount} </span>
                {/* <span className="gr_clr">Fee 0.00020000 BTC</span> */}
              </div>
            </div>
            <div>
              <Button className='rc_amnt_btn w-100' disabled={error.disable || recipientwalletAddress.length < 1} onClick={withdraw}>Withdraw</Button>
            </div>
          </Col>
        </Row>

        {/* Below Row */}
        <Row className="mt-5">
          <Col sm={12}>
            <div className="d-flex justify-content-between">
              <div
                className="head d-flex gap-5 align-items-center"
                style={{ color: "var(--text-clr)" }}
              >
                <h2>Recent Withdrawl Records</h2>
              </div>
            </div>
            {
              data.length > 0 ? <>
                <div className="">
                  <PaginationProvider
                    pagination={paginationFactory(options)}
                  >
                    {
                      ({
                        paginationProps,
                        paginationTableProps
                      }) => (
                        <div>
                          <BootstrapTable
                            keyField="id"
                            bordered={false}
                            defaultSorted={defaultSorted}
                            data={data}
                            columns={columns}
                            {...paginationTableProps}
                          />
                          {
                            data.length > 10 &&
                            <>
                              <PaginationTotalStandalone {...paginationProps} />
                              {/* <SizePerPageDropdownStandalone {...paginationProps} /> */}
                              <PaginationListStandalone {...paginationProps} />
                            </>
                          }

                        </div>
                      )
                    }
                  </PaginationProvider>
                  {/* <ReactTable columns={columns} data={data}  rowsPerPage={10} /> */}
                </div>
              </> : <>
                <div
                  className="d-flex flex-column align-items-center justify-content-center mt-5"
                  style={{ color: "var(--text-clr)" }}
                >
                  <i className="display-6">
                    <HiOutlineDocumentSearch />
                  </i>
                  <span>No recent withdrawl found</span>
                </div>
              </>
            }

          </Col>
        </Row>
      </Container>
    </>
  );
}
